import { useMemo } from "react";
import DataGrid from "components/DataGrid";
import { formatApprovalAmount } from "../utils/formatters";
import { type MilestoneApproval } from "../types";

interface ApprovalConfirmationGridProps {
  milestones: MilestoneApproval[];
  height?: number;
}

/**
 * Simple grid for confirming milestone approvals in modal
 * Shows basic milestone information for confirmation
 */
export const ApprovalConfirmationGrid = ({
  milestones,
  height = 300,
}: ApprovalConfirmationGridProps) => {
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Creator",
        field: "user_id.name",
        flex: 1,
        minWidth: 150,
      },
      {
        headerName: "Brand",
        field: "brand_id.name",
        flex: 1,
        minWidth: 120,
      },
      {
        headerName: "Campaign",
        field: "campaign_id.name",
        flex: 1,
        minWidth: 150,
      },
      {
        headerName: "Milestone",
        field: "name",
        flex: 2,
        minWidth: 200,
      },
      {
        headerName: "Amount",
        field: "rate",
        flex: 1,
        minWidth: 100,
        valueFormatter: (params: any) => formatApprovalAmount(params.value),
      },
    ],
    [],
  );

  return (
    <div style={{ height: `${height}px` }}>
      <DataGrid
        gridId="approval-confirmation"
        quickFilter={false}
        rowData={milestones}
        columnDefs={columnDefs}
        suppressSorting={true}
        suppressMovableColumns={true}
        suppressRowHoverHighlight={false}
        rowSelection="none"
      />
    </div>
  );
};
